import { useState } from "react";
import { Upload, FileSpreadsheet, Check } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Link } from "react-router-dom";

export default function UploadLeads() {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);

  const upload = async () => {
    if (!file) { toast.error("Select a CSV file"); return; }
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const r = await api.post("/leads/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setResult(r.data);
      toast.success(`${r.data.length} prospects imported`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Upload failed");
    } finally { setUploading(false); }
  };

  return (
    <div className="px-6 lg:px-10 py-8 max-w-4xl mx-auto">
      <div className="label-mono mb-2">— CSV Upload</div>
      <h1 className="font-display text-3xl md:text-4xl font-black tracking-tighter mb-2">Import existing lists</h1>
      <p className="text-[#5C5C66] mb-8">Already have a list? Drop it in and personalise outreach for every row.</p>

      <div className="bg-white border-2 border-dashed border-[#EAEAE3] rounded-2xl p-12 text-center hover:border-[#0A0A0F]/30 transition-colors">
        <div className="w-14 h-14 rounded-2xl bg-[#F4F4EE] flex items-center justify-center mx-auto mb-4">
          <FileSpreadsheet className="h-7 w-7 text-[#002FA7]" />
        </div>
        <div className="font-display text-xl font-bold mb-2">{file ? file.name : "Drop your CSV here"}</div>
        <div className="text-sm text-[#5C5C66] mb-6">Required: <span className="font-mono">name</span>. Optional: <span className="font-mono">email, company, title, website, industry, location, linkedin</span></div>
        <input id="csv-input" type="file" accept=".csv" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="csv-input" />
        <div className="flex items-center justify-center gap-3">
          <label htmlFor="csv-input">
            <Button asChild variant="outline" className="rounded-lg border-[#EAEAE3] cursor-pointer">
              <span><Upload className="h-4 w-4 mr-2" /> Choose file</span>
            </Button>
          </label>
          <Button onClick={upload} disabled={!file || uploading} className="rounded-lg bg-[#0A0A0F] hover:bg-[#14141B] text-white shadow-soft" data-testid="csv-upload-btn">
            {uploading ? "Uploading…" : "Upload CSV"}
          </Button>
        </div>
      </div>

      {result && (
        <div className="mt-8 bg-white border border-[#EAEAE3] rounded-2xl p-6 shadow-soft">
          <div className="flex items-center gap-2 text-[#16A34A] mb-4">
            <Check className="h-5 w-5" />
            <span className="font-medium">{result.length} prospects imported</span>
          </div>
          <div className="text-sm text-[#5C5C66] mb-4">Head to your prospects list to draft personalised outreach.</div>
          <Link to="/app/leads"><Button className="rounded-lg bg-[#0A0A0F] hover:bg-[#14141B] text-white">View prospects</Button></Link>
        </div>
      )}
    </div>
  );
}
